import type { MarketVariants } from '@/lib/i18n'

export type Slide7BankExampleCopy = {
  contactName: string
  /** Currency-prefixed amount (e.g. "$847.50" / "£847.50"). Symbol is part of
   *  the value, keeps formatting consistent if a market wants to vary it. */
  fakeAmount: string
  /** Sentence template surrounding `fakeAmount`. Component splices them. */
  bodyBefore: string
  bodyAfter: string
  fakeUrl: string
  whatTheyWant: string
  saferMove: string
  saferMoveTrailer: string
  verifyRoute1: string
  verifyRoute2: string
  verifyRoute3: string
  whatTheyWantLabel: string
  saferMoveLabel: string
  todayPrefix: string
}

export const copy: MarketVariants<Slide7BankExampleCopy> = {
  US: {
    contactName: 'Amazon',
    fakeAmount: '$847.50',
    bodyBefore: 'Your card was used for a payment of ',
    bodyAfter: " at Amazon. If this wasn't you, verify your identity now: ",
    fakeUrl: 'amazon.account-security.com/verify',
    whatTheyWant: 'Panic and click the link without thinking.',
    saferMove: "Step back and slow down. When you're ready, either:",
    saferMoveTrailer:
      'Sender names can be faked. Never trust a message just because it appears to come from a familiar brand.',
    verifyRoute1: 'Log into your Amazon account and check recent orders',
    verifyRoute2: 'Open your banking app and check recent transactions',
    verifyRoute3: 'Call the support number on the back of your credit card',
    whatTheyWantLabel: 'What they want:',
    saferMoveLabel: 'The safer move:',
    todayPrefix: 'Today 9:38 AM',
  },
  GB: {
    fakeAmount: '£847.50',
  },
  // CA, AU inherit US "$847.50", both use $ prefix.
  QA: {
    fakeAmount: 'QAR 3,090',
  },
  ar: {
    contactName: 'أمازون',
    fakeAmount: '3,090 ريال قطري',
    bodyBefore: 'تم استخدام بطاقتك لدفع مبلغ ',
    bodyAfter: ' في أمازون. إذا لم تكن أنت من قام بذلك، فتحقّق من هويتك الآن: ',
    fakeUrl: 'amazon.account-security.com/verify',
    whatTheyWant: 'أن تصاب بالذعر وتضغط على الرابط دون تفكير.',
    saferMove: 'تراجع خطوة وتمهّل. وعندما تكون مستعداً، اختر أحد الخيارات التالية:',
    saferMoveTrailer:
      'يمكن تزييف اسم المرسل. لا تثق برسالة لمجرد أنها تبدو واردة من علامة تجارية مألوفة.',
    verifyRoute1: 'سجّل الدخول إلى حسابك في أمازون وراجع طلباتك الأخيرة',
    verifyRoute2: 'افتح تطبيق البنك وراجع العمليات الأخيرة',
    verifyRoute3: 'اتصل برقم خدمة العملاء المطبوع على ظهر بطاقتك الائتمانية',
    whatTheyWantLabel: 'ما يريدونه:',
    saferMoveLabel: 'الخيار الأكثر أماناً:',
    todayPrefix: 'اليوم 9:38 ص',
  },
}
